<template>
  <DialogWrapper
    close-on-cancel
    class="invite-apply-job-dialog"
    :disabledSaveBtn="!jobList.length > 0"
    :show.sync="show"
    :loading="loading"
    :titleI18nKey="`${i18nPrefix}.title`"
    :saveBtnLabelI18nKey="`${i18nPrefix}.btn.invite`"
    @save="handleSave"
  >
    <WrappedForm
      ref="form"
      hideRequiredAsterisk
      :model="invitation"
      :formLines="formLines"
    >
      <template #jobSelector>
        <div v-if="show && jobList && jobList.length > 0" class="job-selector">
          <el-checkbox
            v-for="(job, index) in jobList"
            class="job-checkbox"
            :key="index"
            :checked="invitation.job.includes(job.id)"
            @change="handelJobCheckboxChange(job)"
          >{{ `${job.id} - ${job.i18nName}` }}</el-checkbox>
        </div>
        <span v-else class="no-job-tip">{{ $t(`${i18nPrefix}.message.noJob`) }}</span>
      </template>
    </WrappedForm>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
export default {
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    jobId: {
      required: false
    },
    candidateId: {
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.invitation.applyJob',
      show: false,
      loading: false,
      jobList: [],
      jobListLoader: null,
      invitation: { job: [] }
    }
  },
  computed: {
    formLines () {
      const i18nPrefix = this.i18nPrefix
      const requiredMessage = this.$t('common.message.requiredFormField')
      const lines = {
        job: {
          label: this.$t(`${i18nPrefix}.label.job`),
          contentSlot: 'jobSelector',
          rules: [{ validator: this.validateJob, trigger: 'change' }]
        },
        subject: {
          label: this.$t(`${i18nPrefix}.label.subject`),
          disabled: !this.jobList.length > 0,
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        content: {
          label: this.$t(`${i18nPrefix}.label.content`),
          props: { type: 'textarea', autosize: { minRows: 5 } },
          disabled: !this.jobList.length > 0,
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        }
      }
      return lines
    },
    form () {
      return this.$refs.form
    }
  },
  created () {

  },
  methods: {
    ...mapActions('application', ['inviteCandidateApplyJob', 'getCandidateCanInviteJobList']),
    openDialog () {
      this.show = true
    },
    async clearForm () {
      this.invitation = { job: [] }
      this.$nextTick(() => {
        this.form.clearValidate()
      })
    },
    handelJobCheckboxChange (job) {
      const jobId = job.id
      if (this.invitation.job.includes(jobId)) {
        _.remove(this.invitation.job, jobId)
      } else {
        this.invitation.job.push(jobId)
      }
    },
    validateJob (rule, value, callback) {
      if (!value || value.length < 1) {
        callback(new Error(this.$t(`${this.i18nPrefix}.message.atLeastOneJob`)))
        return
      }
      callback()
    },
    async loadJobList () {
      this.loading = true
      if (!this.jobListLoader) {
        this.jobListLoader = this.getCandidateCanInviteJobList({ candidate_ids: this.candidateId }).then((resp) => {
          const jobList = []
          _.forEach(resp, job => {
            if (job.id === this.jobId) {
              return
            }
            addI18nProperty(job, 'i18nName', 'cn_title', 'title')
            jobList.push(job)
          })
          this.jobList = jobList
          return this.jobList
        })
      }
      await this.jobListLoader
      this.loading = false
      return this.jobList
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      const isValid = await this.form.submit()
      if (!isValid) {
        return
      }
      this.loading = true
      const invitation = {
        current_job_id: this.jobId,
        candidate_ids: [this.candidateId],
        job_ids: this.invitation.job,
        subject: this.invitation.subject,
        content: this.invitation.content
      }
      const resp = await this.inviteCandidateApplyJob(invitation)
      if (resp) {
        this.loading = false
        if (resp.success && resp.success.length > 0) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteSuccess`))
          this.show = false
        } else if (resp.no_email_count && resp.no_email_count.length > 0) {
          this.$message.warning(this.$t(`${this.i18nPrefix}.message.inviteNoEmailAccount`))
        } else if (resp.over_times_count && resp.over_times_count.length > 0) {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.inviteOverLimitTimes`))
        } else {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.inviteFail`))
        }
      }
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.clearForm()
        this.loadJobList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-apply-job-dialog {
  .job-selector {
    max-height: 40vh;
    min-height: 40px;
    padding: 6px 0;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    overflow: auto;

    .job-checkbox {
      display: block;
      padding: 6px 15px;
      font-size: 12px;
      line-height: 1;

      &:hover {
        background-color: #f5f7fa;
      }

      ::v-deep .el-checkbox__label {
        vertical-align: middle;
      }
    }
  }

  .no-job-tip {
    display: block;
    margin-top: -2px;
  }
}
</style>
